// extracted by mini-css-extract-plugin
export var card = "ProjectFullCard-module--card--c5620";
export var card__arrowUpRight = "ProjectFullCard-module--card__arrowUpRight--86fe1";
export var card__desc = "ProjectFullCard-module--card__desc--ae5d8";
export var card__desc___active = "ProjectFullCard-module--card__desc___active--b137e";
export var card__footer = "ProjectFullCard-module--card__footer--3bc2a";
export var card__image = "ProjectFullCard-module--card__image--89aaf";
export var card__subtitle = "ProjectFullCard-module--card__subtitle--5b2b8";
export var card__tag = "ProjectFullCard-module--card__tag--dfe07";
export var card__title = "ProjectFullCard-module--card__title--d8bfb";
export var card__titleWrapper = "ProjectFullCard-module--card__titleWrapper--3ad33";